<template>
    <div id="dynamic-template">

        <!-- <div v-if="load_states.error" class="p-30 container text-center">
            <hr style="
                width: 10px;
                height: 10px;
                border-radius: 30px;
                background: red;
                border: none;
                outline: none;
            " />
            <h1 class="m-0 mb-5 lh-34 fs-20">Redirecting to standard splash page</h1>
            <small>(custom splash name mismatch)</small>
        </div> -->

        <div v-if="load_states.loaded">
            <component
                :is="component"
                :template="template"
                :load_states="parent_load_states"
                :error="parent_error"
                :portal="portal"
                :connection_data="connection_data"
                v-on:emitRegistrationMethodData="emitRegistrationMethodData"
                v-on:emitCustomError="emitCustomError"
                v-if="component"
            />
        </div>

    </div>
</template>
<script>
export default {
    name: 'dynamic-template',
    props: [
        'template',
        'portal',
        'connection_data',
        'parent_load_states',
        'parent_error'
    ],
    data() {
        return {
            load_states: {
                loading: true,
                loaded: false,
                error: false,
            },
            error: {
                status: null,
                message: null,
                invalid_fields: null,
            },
            component: null
        }
    },
    computed: {
        loader() {
            return () => import(`@/components/custom/${this.template}`)
        },
    },
    mounted() {
        this.loader()
            .then(() => {
                this.component = () => this.loader()
                this.changeLoadState('loaded')
            })
            .catch((e) => {
                // this forces a redirect to a standard splash page in the event an error occurs
                // with this custom splash page. likely the error is a mismatch between the splash
                // page name and the directory that is serving that splash page here
                this.$emit('force_standard', true);
                //some error handling here
                this.error.status = 'Error';
                this.error.message = e.message ? e.message : e;
                this.changeLoadState('error');
                return;
            })
        },
    methods: {
        changeLoadState: function(state){
          for (var load_state in this.load_states) {
            this.load_states[load_state] = (state == load_state) ? true : false;
          }
        },
      emitCustomError: function (error) {
          this.$emit('emitCustomError', error);
      },
        // Send registration method details back to parent
        emitRegistrationMethodData:function(emitted){
          // Check the template for v-on:emitRegistrationMethodData
          this.$emit('emitRegistrationMethodData',emitted);
        }
    }
}

</script>
